import { render, staticRenderFns } from "./CreateEditRecipe.vue?vue&type=template&id=65ef3faf&"
import script from "./CreateEditRecipe.vue?vue&type=script&lang=js&"
export * from "./CreateEditRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports